import { FaberApi, JetpacPayApi, OrbitPayApi } from 'api'
import { AxiosPromise } from 'axios'
import { NotificationGetEmailHistory } from 'types/api/faber/notification.type'

class NotificationAPI {
  /**
   * to list all notifications sent to the customer
   */
  static getEmailNotificationHistory(
    userId: string,
    faberToken: string
  ): AxiosPromise<NotificationGetEmailHistory> {
    const response = FaberApi.httpGet(
      `/sim/notification/email/user/${userId}`,
      {
        Authorization: `Bearer ${faberToken}`
      }
    )
    return response
  }

  static getExternalEmailNotificationHistory(
    userId: string,
    faberToken: string
  ): AxiosPromise<NotificationGetEmailHistory> {
    const response = FaberApi.httpGet(
      `/sim/ext/notification/email/user/${userId}`,
      {
        Authorization: `Bearer ${faberToken}`
      }
    )
    return response
  }

  static sendSubscriptionReceipt({ paymentId, faberToken }: ReceiptProps) {
    const response = FaberApi.httpPost(
      `/order/receipt`,
      {
        Authorization: `Bearer ${faberToken}`
      },
      {
        paymentId: paymentId
      }
    )
    return response
  }

  static sendOtpackReceipt({ paymentId, faberToken }: OtpackReceiptProps) {
    const response = FaberApi.httpPost(
      `/sim/ops/plan/receipt`,
      {
        Authorization: `Bearer ${faberToken}`
      },
      {
        paymentId: paymentId
      }
    )
    return response
  }

  static sendGlobalReceipt({ paymentId, userId, faberToken, email }: GlobalReceiptProps) {
    return JetpacPayApi.httpPost(
      `/SGP/ops/stripe/receipt`,
      {
        Authorization: `Bearer ${faberToken}`
      },
      {
        paymentId: paymentId,
        userId: userId,
        ...(email && { email: email })
      }
    )
  }

  static sendExternalGlobalReceipt({
    paymentId,
    userId,
    faberToken
  }: GlobalReceiptProps) {
    const response = FaberApi.httpPost(
      `/sim/ext/plan/receiptv2`,
      {
        Authorization: `Bearer ${faberToken}`
      },
      {
        paymentId: paymentId,
        userId: userId
      }
    )
    return response
  }

  static sendRefundReceipt({ paymentId, faberToken }: RefundReceiptProps) {
    const response = OrbitPayApi.httpPost(
      `/payment/stripe/refund/receipt`,
      {
        Authorization: `Bearer ${faberToken}`
      },
      {
        paymentId: paymentId
      }
    )
    return response
  }

  static async uploadFileAndSendPushNotification({
    uploadObject,
    faberToken
  }: {
    faberToken: string
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    uploadObject: any
  }) {
    return FaberApi.httpPost(
      '/sim/notification/push/bulk',
      {
        Authorization: `Bearer ${faberToken}`,
        'Content-Type': 'multipart/form-data'
      },
      uploadObject
    ).then((res) => res.data)
  }

  static async getPushNotificationHistory(faberToken: string) {
    return FaberApi.httpGet(
      '/sim/notification/push/logs',
      {
        Authorization: `Bearer ${faberToken}`
      },
      true
    ).then((res) => res.data)
  }
}

export default NotificationAPI

interface ReceiptProps {
  paymentId: string
  faberToken: string
}
interface OtpackReceiptProps {
  paymentId: string
  faberToken: string
}
interface RefundReceiptProps {
  paymentId: string
  faberToken: string
}

interface GlobalReceiptProps {
  paymentId: string
  userId: string
  faberToken: string
  email?: string
}
